export default __webpack_public_path__ + "static/media/SCiO-sLogo-Dark.7ffb4dad.png";